import { useScans } from '../hooks/useScans.js';

// T384 — the same fetch, where he is looking.
//
// The button lived only on the dashboard, and the two screens that exist
// BECAUSE of mail — the Mail tab and Tasks — had no way to ask for any. He
// asked for it on Mail, which is the obvious place: you go there to see
// replies, find none, and there is nothing on the page to do about it.
//
// One shared component and one shared hook rather than a second trigger: the
// dashboard's version already handles the enqueue, the poll, every failure
// code and the report, and a copy would drift from it the first time either
// changed.
export default function FetchMailButton({ onDone, className = '' }) {
  // `refresh` is the hook's own name for what runs after a scan settles.
  const { imapScanning, triggerImapScan } = useScans({ refresh: onDone ?? (() => {}) });

  return (
    <button
      type="button"
      onClick={triggerImapScan}
      disabled={imapScanning}
      aria-busy={imapScanning}
      title="Read your inbox: employer replies and job alerts (read-only)"
      className={
        'rounded-md border border-slate-700 px-3 py-1.5 text-xs text-slate-300 transition hover:border-brand-600 hover:text-brand-400 disabled:opacity-50 ' +
        className
      }
    >
      {imapScanning ? 'reading inbox…' : '📧 Fetch mail'}
    </button>
  );
}
